import { useCallback } from 'react';
import { FieldErrors, Resolver } from 'react-hook-form';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { BoloPanelFormType } from '@mark43/cad-api';
import { validationError } from '../../../panels/entity-panels/forms/validation';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { validateEntityPanelVehicles } from '../../../panels/entity-panels/forms/vehicles/validate-entity-panel-vehicles';
import { stubEntityFormFields } from '../../../panels/entity-panels/forms/stub-entity-form-fields';
import { validateEntityPanelPersonsForm } from '../../../panels/entity-panels/forms/persons/validate-entity-panel-persons';

export function useBoloPanelFormValidationResolver(): Resolver<BoloPanelFormType> {
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const enabledFeatures = useEnabledFeatures();
    const boloDoesNotExist = true;

    return useCallback(
        async (form) => {
            const entityForm = {
                ...stubEntityFormFields,
                ...form,
            };

            const errors: FieldErrors<BoloPanelFormType> = {};
            if (!form.boloType) {
                errors.boloType = validationError('Required');
            }
            if (!form.priority) {
                errors.priority = validationError('Required');
            }

            validateEntityPanelPersonsForm({
                baseKey: 'involvedPersons',
                enabledFeatures,
                eventPanelOptions,
                form: entityForm,
                entityExists: !boloDoesNotExist,
                existingErrors: errors,
            });

            validateEntityPanelVehicles({
                form: entityForm,
                baseKey: 'involvedVehicles',
                eventPanelOptions,
                existingErrors: errors,
            });

            if (Object.keys(errors).length > 0) {
                return {
                    values: {},
                    errors,
                };
            } else {
                return {
                    values: form,
                    errors: {},
                };
            }
        },
        [boloDoesNotExist, enabledFeatures, eventPanelOptions]
    );
}
